import actionTypes from './actionTypes';

export const logoutRequest = () => ({
  type: actionTypes.LOGOUT_REQUEST,
});

export const logoutReceive = () => ({
  type: actionTypes.LOGOUTـRECEIVE,
});
